export default "__VITE_ASSET__08ee4aad__"